import { httpCreate } from './http.js';
import config from './config';

const http = httpCreate('/services/app');
const servicesAppUrl = `${config.cardHost}/services/app`;
export const services = {
	getBannerUrl(type, title, date) {
		return `${servicesAppUrl}/banner/img/${type}/${title}/${date}.png`;
	},
	getBeforeUrl(type, title) {
		return `${servicesAppUrl}/banner/tw/${type}/${title}.png`;
	},
	getMp3Url(url) {
		return `${servicesAppUrl}/mp3/play/${url}.mp3`;
	},
	async getPlayerUrl(activityId, pullvalidityTime) {
		const { data, ok } = await http.get(`/player/encode/${activityId}?t=${pullvalidityTime}`);
		if (!ok) return;
		let playerId = data.data;
		return `${config.host}/services/app/player/play/${playerId}`;
	},
};

